module.exports = __webpack_public_path__ + "img/ds_yd.5542e125.png";